<script setup lang="ts">
export type SurfaceVariants =
  | 'surface_btn_default' //
  | 'surface_btn_primary'
  | 'surface_1'
  | 'surface_2'

export interface SurfaceProps {
  variant: SurfaceVariants
  // eslint-disable-next-line no-undef
  tag?: keyof HTMLElementTagNameMap
}

withDefaults(defineProps<SurfaceProps>(), {
  tag: 'div',
})
</script>

<template>
  <component
    :is="tag"
    :class="variant"
  >
    <slot></slot>
  </component>
</template>
